'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UITag from 'UIComponents/tag/UITag';
import UIClickable from 'UIComponents/button/UIClickable';
const StyledClickable = styled(UIClickable).withConfig({
  displayName: "MobileTagButton__StyledClickable",
  componentId: "sc-157ud49-0"
})(["&&{line-height:normal;}"]);
const StyledTag = styled(UITag).withConfig({
  displayName: "MobileTagButton__StyledTag",
  componentId: "sc-157ud49-1"
})(["&&{line-height:32px;}"]);

const MobileTagButton = ({
  children,
  onClick,
  closeable
}) => {
  return /*#__PURE__*/_jsx(StyledClickable, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(StyledTag, {
      use: closeable ? 'calypso' : undefined,
      closeable: closeable,
      children: children
    })
  });
};

MobileTagButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  closeable: PropTypes.bool
};
export default MobileTagButton;